import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-page-intro-copy',
  templateUrl: './page-intro-copy.component.html',
  styleUrls: ['./page-intro-copy.component.scss']
})
export class PageIntroCopyComponent {

  @Input() html: SafeHtml;

}
